export const APP_TIMEZONE = 'Africa/Cairo';

export const DEFAULT_TIMEZONE_SETTINGS = {
  businessCountryCode: 'EG',
  businessUtcOffsetMinutes: 120,
  clockCorrectionMinutes: 0
};

export const getZonedParts = (date, offsetMinutes = 120) => {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const offset = Number(offsetMinutes) || 0;
  const shifted = new Date(d.getTime() + offset * 60 * 1000);
  return {
    year: shifted.getUTCFullYear(),
    month: shifted.getUTCMonth() + 1,
    day: shifted.getUTCDate(),
    hour: shifted.getUTCHours(),
    minute: shifted.getUTCMinutes(),
    second: shifted.getUTCSeconds()
  };
};

export const zonedWallTimeToDate = ({
  year,
  month,
  day,
  hour,
  minute,
  second = 0
}, offsetMinutes = 120) => {
  const offset = Number(offsetMinutes) || 0;
  return new Date(Date.UTC(year, month - 1, day, hour, minute, second) - offset * 60 * 1000);
};

export const startOfZonedDay = (date, offsetMinutes = 120) => {
  const parts = getZonedParts(date, offsetMinutes);
  if (!parts) return null;
  return zonedWallTimeToDate({
    year: parts.year,
    month: parts.month,
    day: parts.day,
    hour: 0,
    minute: 0,
    second: 0
  }, offsetMinutes);
};

export const buildZonedDateTimeOnDay = (dayDate, timeHHMM, offsetMinutes = 120) => {
  if (!timeHHMM) return null;
  const day = startOfZonedDay(dayDate, offsetMinutes);
  if (!day) return null;
  const parts = getZonedParts(day, offsetMinutes);
  if (!parts) return null;
  const [h, m] = String(timeHHMM).split(':').map(Number);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return zonedWallTimeToDate({
    year: parts.year,
    month: parts.month,
    day: parts.day,
    hour: h,
    minute: m,
    second: 0
  }, offsetMinutes);
};

export const applyClockCorrection = (value, clockCorrectionMinutes = 0) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return date;
  const minutes = Number(clockCorrectionMinutes) || 0;
  if (!minutes) return date;
  return new Date(date.getTime() + minutes * 60 * 1000);
};
